import React, { useState } from 'react';

const ContactTestimonials = () => {
  const [isPaused, setIsPaused] = useState(false);

  const testimonials = [
    {
      id: 1,
      text: "Avexa Systems has simplified care delivery across hospitals and homes. The platform is intuitive, reliable, and truly improves patient outcomes.",
      name: "~ Aarav",
    },
    {
      id: 2,
      text: "Avexa Systems delivers a seamless experience for care teams and patients alike. It’s a dependable solution built for modern healthcare needs.",
      name: "~ Ananya",
    },
    {
      id: 3,
      text: "With Avexa Systems, managing care feels effortless. It bridges hospitals and home care with efficiency and confidence.",
      name: "~ Rohan",
    },
    {
      id: 4,
      text: "Avexa Systems makes connected care simple, efficient, and reliable for both hospitals and home environments.",
      name: "~ Kavya",
    },
    {
      id: 5,
      text: "Avexa Systems has transformed how we approach care delivery. It’s intuitive, secure, and designed with real-world healthcare in mind.",
      name: "~ Vikram",
    }
  ];

  // Duplicate testimonials for seamless infinite scroll
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  return (
    <section className="w-full bg-white py-16">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-4">
          <span className="primary-text">Testimonials From Our </span><span className="secondary-text"> Valued Clients</span>
        </h2>
        {/* <p className="text-center text-gray-600 max-w-3xl mx-auto">
          Hear how our innovative approach has helped organizations improve care delivery and outcomes.
        </p> */}
      </div>

      {/* Scrolling Testimonials */}
      <div className="relative w-full overflow-hidden">
        <div
          className="flex gap-6 px-6"
          style={{
            animation: isPaused ? 'none' : 'scroll 30s linear infinite',
          }}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          {duplicatedTestimonials.map((testimonial, index) => (
            <div
              key={`${testimonial.id}-${index}`}
              className="flex-shrink-0 bg-white rounded-xl shadow-lg p-6 w-80 transition-transform hover:scale-105 flex flex-col justify-between"
              style={{ height: '180px' }}
            >
              <p className="primary-text text-sm leading-relaxed flex-grow overflow-hidden">
                {testimonial.text}
              </p>
              <h4 className="mt-4 font-semibold primary-text">
                {testimonial.name}
              </h4>
            </div>
          ))}
        </div>
      </div>

      {/* Animation */}
      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </section>
  );
};

export default ContactTestimonials;
